<template>
  <div class="dashboard-tab">
    <div class="row">
      <div class="col">
        <vuestic-pre-loader v-show="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
        <router-view v-show="!isLoading"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Sidebar from '../sidebar/Sidebar'
  import Navbar from '../navbar/Navbar'
  import menu from '../../../store/modules/menu'

  export default {
    name: 'resource-tab',
    data: function () {
      return {
        flow: localStorage.getItem('flow-token'),
        items: menu.state.items
      }
    },
    props: {
      fixed: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      Navbar,
      Sidebar
    },
    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation',
        'isLoading'
      ]),
      classObject: function () {
        return {
          'layout-fixed': this.fixed,
          'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
          'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
        }
      },
      breadcrumbs () {
        return this.$store.getters.breadcrumbs(this.$route.name)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../sass/_variables.scss";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "~bootstrap/scss/mixins/breakpoints";
</style>



// WEBPACK FOOTER //
// src/components/layout/resource-tab/Resource.vue